import { Service, signal } from '@angular/core';

const STORAGE_KEY = 'saphir-web.sidebar-collapsed';

/**
 * Whether the sidebar is an icon rail or shows its labels.
 *
 * A service rather than component state because two components share it: the
 * header owns the burger, the sidebar renders the consequence. The choice is
 * remembered — someone who prefers the rail prefers it tomorrow too, the same
 * reasoning as the theme.
 */
@Service()
export class SidebarStateService {
  private readonly state = signal<boolean>(restore());

  readonly collapsed = this.state.asReadonly();

  toggle(): void {
    this.state.update((collapsed) => !collapsed);
    persist(this.state());
  }
}

// Storage is unavailable in private windows and behind some policies. Losing
// the preference is a small thing; failing to toggle is not.
function restore(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

function persist(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(collapsed));
  } catch {
    // Ignored on purpose — see above.
  }
}
